import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="PHP">
                <h1>PHP Development Company For A Strong Backend Support</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol offers comprehensive PHP development services for
                  your business's backend solutions. Our experts create custom
                  solutions with all the necessary features and functionalities
                  for your unique requirements.
                </p>
                <ul>
                  <li>Customized solutions</li>
                  <li>Strong backend support</li>
                  <li>Excellent functionalities</li>
                  <li>Varying business needs</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
